import { showPreview, getMultiIcon, showUppertitle, urlDev} from "../../Config/Functions/Functions"

const SeccionActual = ({data}) => {
    let count = 0
    return (
        <>
        {
            data[6] ? 
                <div className="single-vertical-section">
                    <header>
                        <h3 className="vertical-section-title">
                            <a href={data[0].info?.section?.url} title={`Ver más notas de sección ${data[0].info?.section?.name}`}>{data[0].info?.section?.name}</a>
                        </h3>
                    </header>
                    <div className="extra-holder has-mobile-gutter">
                    {
                            data.map((dat, index) =>{
                                if(count === 6){
                                    count++
                                    return (
                                        <article className="medium-entry-box" key={index}>
                                            <picture>
                                                {
                                                    dat.preview ?
                                                    <>
                                                        <img src={urlDev+dat.preview.sizes[1]?.url} width={320} height={180} alt={dat.main?.title?.home} title={dat.main?.title?.home} loading="lazy"/>
                                                    </>
                                                    :
                                                    <>
                                                        {showPreview(dat.main?.title?.home, "320", "180")}
                                                    </>
                                                } 
                                                {/*getMultiIcon(dat.hascontent.hasgalleryvideosyoutube, dat.gallery.length > 1, dat.hascontent.hasaudios)*/}
                                            </picture>
                                            <div className="entry-data">
                                                <h2 className="entry-title">
                                                    {showUppertitle(dat.main?.uppertitle)}
                                                    {dat.main?.title?.home}
                                                </h2>
                                            </div>
                                            <a href={dat.info?.link?.url} className="cover-link" title={dat.main?.title?.home}></a>
                                        </article>
                                    )
                                }if(count > 6){
                                    count++
                                    return (
                                        <article className="medium-entry-box" key={index}>
                                            <div className="entry-data">
                                                <h2 className="entry-title">
                                                    {showUppertitle(dat.main?.uppertitle)}
                                                    {dat.main?.title?.home}
                                                </h2>
                                            </div>
                                            <a href={dat.info?.link?.url} className="cover-link" title={dat.main?.title?.home}></a>
                                        </article>
                                    )
                                }else{
                                    count++
                                    return null
                                }
                            })
                        }
                    </div>
                </div>
            :null
        }
        </>
    )
}

export default SeccionActual;